var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonIconImgMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0015 0.0214844C4.94161 0.0214844 0.0234375 4.93965 0.0234375 10.9995C0.0234375 17.0594 4.94161 21.9776 11.0015 21.9776C17.0614 21.9776 21.9796 17.0594 21.9796 10.9995C21.9796 4.93965 17.0614 0.0214844 11.0015 0.0214844ZM11.0015 4.41271C13.1203 4.41271 14.8438 6.13626 14.8438 8.25503C14.8438 10.3738 13.1203 12.0973 11.0015 12.0973C8.88273 12.0973 7.15917 10.3738 7.15917 8.25503C7.15917 6.13626 8.88273 4.41271 11.0015 4.41271ZM11.0015 19.782C8.77295 19.782 6.13822 18.8818 4.26097 16.6203C6.11626 15.1712 8.45459 14.293 11.0015 14.293C13.5484 14.293 15.8867 15.1712 17.742 16.6203C15.8648 18.8818 13.23 19.782 11.0015 19.782Z",
    fill: "#6C7389"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIconImgMd);
export default __webpack_public_path__ + "static/media/person_icon_img_md.e949b7e5c7f16e849fe697ad45f64c8f.svg";
export { ForwardRef as ReactComponent };